module.exports = __webpack_public_path__ + "img/image (13).ef2d1db9.jpg";